/**
 * 安全配置
 */

import CNF from '../../incs/Config.js';
import {
    AddRequestHeaders,
    UjoinParams,
    uploadAvatarButton,
    AliyunOSSclient,
    AliyunOSSDelete,
    uuid,
    GetBase64,
} from '../../incs/FunHelper';

import { useState, useEffect } from 'react';
import {
    Row,
    Col,
    Progress,
    Upload,
    Image,
    message,
    Divider,
    theme,
    Typography,
} from 'antd';
import $ from 'jquery';
import {
    PlusOutlined,
    CheckOutlined,
} from '@ant-design/icons';
import ImgCrop from 'antd-img-crop';


const { Title } = Typography;

const Entity = (props) => {
    const [messageApi, contextHolder] = message.useMessage();

    const [basicinfo, setBasicinfo] = useState({});
    const [sLevel, setSLevel] = useState(30);
    const [fileList, setFileList] = useState([]);    //  图片列表
    const [previewOpen, setPreviewOpen] = useState(false); //  图片预览是否打开
    const [previewImage, setPreviewImage] = useState(''); //  图片预览资源

    const {
        token: { colorPrimary, colorPrimaryActive },
    } = theme.useToken();

    useEffect(() => {
        // 初始化账户基础信息
        $.ajax({
            url: `${CNF.api}users/basicinfo`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    let basicinfo = data.dat;
                    setBasicinfo(basicinfo);
                    /***
                     * 判断用户安全级别
                     * 1、只有密码是为弱；
                     * 2、电话邮箱绑定其一是为中；
                     * 3、电话邮箱全绑定是为强；
                     */
                    let sLevel = 0;
                    if (basicinfo.phone === '' && basicinfo.email === '') {
                        sLevel = 30;
                    } else if (basicinfo.phone !== '' && basicinfo.email !== '') {
                        sLevel = 100;
                    } else {
                        sLevel = 60;
                    }
                    setSLevel(sLevel);
                    if (basicinfo.avatar_url) {
                        let fileList = [];
                        const url = CNF.ossApi + basicinfo.avatar_url;
                        fileList.push({
                            uid: 1,
                            url: url,
                            path: basicinfo.avatar_url,
                            preview: url,
                            status: 'done',
                            percent: 100,
                        });
                        setFileList(fileList);
                    }
                }
            }
        });
    }, []);

    const renderSLevelColor = () => {
        let sLevelColor = '';
        if (sLevel <= 30) {
            sLevelColor = '#EF6730';
        } else if (sLevel <= 60) {
            sLevelColor = '#FAAD13';
        } else {
            sLevelColor = '#5EC41D';
        }
        return sLevelColor;
    }

    const renderSLevelMsg = () => {
        let sLevelMsg = '';
        if (sLevel <= 30) {
            sLevelMsg = '弱';
        } else if (sLevel <= 60) {
            sLevelMsg = '中';
        } else {
            sLevelMsg = '强';
        }
        return <span>{sLevelMsg}</span>;
    }

    /**
     * 图片预览操作绑定函数
     * @param {*} file 
     */
    const preview = (file) => {
        if (!file.preview) {
            if (file.originFileObj) {
                //  转换图片，用于缩略图展示
                GetBase64(file.originFileObj, (imageObj) => {
                    file.preview = imageObj;
                });
            } else {
                file.preview = file.url;
            }
        }
        setPreviewImage(file.preview || file.url);
        setPreviewOpen(true);
    }

    /**
     * 文件上传前钩子
     * @param {*} file 
     */
    const beforeUpload = (file) => {
        //  判断格式
        if (!['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)) {
            messageApi.error('上传图片格式错误！', CNF.messageDuration);
            return false;
        }
        if (file.size > 5242880) {
            messageApi.error('上传图片超过500KB，请重新上传！', CNF.messageDuration);
            return false;
        }
        return true;
    }

    /**
     * 存储到阿里云
     * @param {*} file 
     * @returns 
     */
    const aliyunOSSUpload = (file, acl = 'public-read') => {
        const headers = {
            //  文件acl授权为公共读
            'x-oss-object-acl': acl
        }
        var params = {
            'oss': 'PutObject',
        }
        $.ajax({
            url: CNF.cfmsApi + 'oss/aliyunoss2/sts' + UjoinParams(params),
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    const token = data.dat;
                    try {
                        let reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onloadend = () => {
                            //  路径由以下部分组成
                            //  项目代码+avatar+组织前缀+uuid+附件名（去除空格）
                            let path = CNF.projectCode.toLowerCase()
                            path += '/avatar';
                            path += '/' + props.preGroup;
                            path += '/' + uuid;
                            path += '/' + file.name.replace(/\s/g, '');
                            // 获取最新的文件列表
                            let newFileList = [...fileList];
                            AliyunOSSclient(token).multipartUpload(path, file,
                                {
                                    //  请求头
                                    headers,
                                    //  获取分片上传进度、断点和返回值
                                    progress: (p) => {
                                        setFileList(prevItems => {
                                            let newItems = [...prevItems]; // 创建数组的副本
                                            newItems[newItems.length - 1] = {
                                                ...newItems[newItems.length - 1],
                                                percent: parseInt(p * 100),
                                                status: p === 1 ? 'done' : 'uploading',
                                                url: CNF.ossApi + path,
                                                path: path,
                                            }; // 更新对象
                                            return newItems; // 返回新的数组
                                        })
                                    },
                                    //  分片数量
                                    parallel: Math.ceil(file.size / 1024 / 1024),
                                    //  设置分片大小，默认为1M。
                                    partSize: 1024 * 1024,
                                    mime: "text/plain",
                                }).then((result) => {
                                    //  上传成功
                                    if (result.res.status === 200) { }
                                }).catch((e) => {
                                    //  上传失败
                                    messageApi.error(file.name + ' 上传失败！', CNF.messageDuration);
                                    setFileList(newFileList.pop());
                                });
                        }
                    } catch (e) {
                        console.log(e);
                    }
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        });
        return false
    }

    const updateAvatar = (avatarUrl) => {
        //  执行修改
        $.ajax({
            url: `${CNF.api}users/${basicinfo.ulid}`,
            headers: AddRequestHeaders(),
            type: 'PUT',
            dataType: 'JSON',
            data: JSON.stringify({
                'action': 'UPDATE_AVATAR',
                'avatar_url': avatarUrl,
            }), success: function (data) {
                if (data.res === 0) {
                    messageApi.success(data.msg, CNF.messageDuration);
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        });
    }
    return (
        <div style={{ height: '100%', padding: '0 30px' }}>
            {contextHolder}
            <Title level={5}>{props.m > 0 ? CNF.navUserItems[props.m - 1].name : ''}</Title>
            <Divider style={{ borderColor: colorPrimary }} />
            <Row style={{ padding: '20px 0' }}>
                <Col span={2}>
                    <ImgCrop rotationSlider>
                        <Upload
                            name='avatar'
                            beforeUpload={beforeUpload}
                            listType='picture-circle'
                            style={{ padding: 0 }}
                            icon={<PlusOutlined />}
                            customRequest={(option) => { aliyunOSSUpload(option.file); }}
                            fileList={fileList}
                            onPreview={preview}
                            onChange={({ fileList: newFileList }) => {
                                setFileList(newFileList);
                            }}
                            onRemove={(file) => {
                                // 从阿里云上删除
                                AliyunOSSDelete(file);
                                updateAvatar('');
                            }}
                        >
                            {fileList.length > 0 ? null : uploadAvatarButton}
                        </Upload>
                        {previewImage && (
                            <Image
                                wrapperStyle={{
                                    display: 'none',
                                }}
                                alt='avatar'
                                style={{
                                    width: '100%',
                                }}
                                preview={{
                                    visible: previewOpen,
                                    onVisibleChange: (visible) => setPreviewOpen(visible),
                                    afterOpenChange: (visible) => !visible && setPreviewImage(''),
                                }}
                                src={previewImage}
                            />
                        )}
                    </ImgCrop>
                </Col>
                <Col span={5}>
                    <p style={{ marginTop: 2 }}><label>登录账户: </label>{basicinfo.username}</p>
                    <p><label>显示名称: </label>{basicinfo.displayname}</p>
                    <p><label>注册时间: </label>{basicinfo.create_time}</p>
                </Col>
            </Row>
            <Row style={{ padding: '20px 0' }}>
                <Col span={2}><strong style={{ color: colorPrimaryActive }}>安全等级</strong></Col>
                <Col span={2}>
                    <Progress
                        strokeLinecap='square'
                        showInfo={false}
                        strokeColor={renderSLevelColor()}
                        percent={sLevel}
                        size={{ width: 30 }}
                        steps={3}
                    />
                </Col>
                <Col span={1} style={{ padding: '0 10px' }}>{renderSLevelMsg()}</Col>
            </Row>
            <Row style={{ padding: '20px 0' }}>
                <Col span={2}><strong style={{ color: colorPrimaryActive }}>登录密码</strong></Col>
                <Col span={18}><label>安全性高的密码可以使帐号更安全。建议您定期更换密码，设置一个包含字母，符号或数字中至少两项且长度超过 <strong>6</strong> 位的密码。</label></Col>
                <Col span={2} style={{ color: '#049A02' }}><CheckOutlined /> 已设置 </Col>
                <Col span={2}><a href={(CNF.basename ? CNF.basename : '') + '/user/security/update/m=password&t=' + Date.parse(new Date()) / CNF.tDivisor + '&u=true'} target='_blank' rel='noopener noreferrer'>修改</a></Col>
            </Row>
            <Row style={{ padding: '20px 0' }}>
                <Col span={2}><strong style={{ color: colorPrimaryActive }}>手机绑定</strong></Col>
                <Col span={18}><label>您已绑定了手机 <strong style={{ color: '#EF6730' }}>{basicinfo.phone}</strong> [您的手机为安全手机，可用于找回密码]</label></Col>
                <Col span={2} style={{ color: '#049A02' }}><CheckOutlined /> 已设置 </Col>
                <Col span={2}><a href={(CNF.basename ? CNF.basename : '') + '/user/security/update/m=phone&t=' + Date.parse(new Date()) / CNF.tDivisor + '&u=true'} target='_blank' rel='noopener noreferrer'>修改</a></Col>
            </Row>
            <Row style={{ padding: '20px 0' }}>
                <Col span={2}><strong style={{ color: colorPrimaryActive }}>邮箱绑定</strong></Col>
                <Col span={18}><label>您已绑定了邮箱 <strong style={{ color: '#EF6730' }}>{basicinfo.email}</strong> [您的邮箱为安全邮箱，可用于找回密码]</label></Col>
                <Col span={2} style={{ color: '#049A02' }}><CheckOutlined /> 已设置 </Col>
                <Col span={2}><a href={(CNF.basename ? CNF.basename : '') + '/user/security/update/m=email&t=' + Date.parse(new Date()) / CNF.tDivisor + '&u=true'} target='_blank' rel='noopener noreferrer'>修改</a></Col>
            </Row>
        </div>
    );
}

export default Entity;